import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { JurisdictionSettings } from "../models/jurisdiction-settings.model";
import { JurisdictionSettingsService } from "../services/jurisdiction-settings.service";

@Directive({ selector: '[spv2ShowForJurisdiction]' })
export class ShowForJurisdictionDirective {
  constructor(
    private readonly jurisdictionServiceSettings: JurisdictionSettingsService,
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef
  ) { }

  @Input('spv2ShowForJurisdiction') set showForJurisdiction(model: showForJurisdictionModel) {
    if (!model) throw "You must provide a showForJurisdictionModel to check for in the ShowForJurisdictionDirective";
    if (this.jurisdictionServiceSettings.getCurrentSettings(model.jurisdictionCode)[model.property]) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}

export class showForJurisdictionModel {
  constructor(public jurisdictionCode: string, public property: string) {
    if (!JurisdictionSettings.hasOwnProperty(property)) throw "Please provide a correct property of JurisdictionSettings";
  }
}